<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search ref="buttonSearch" placeholder="搜索名称 | 代码" @search="searchEvent" :showGj="false">
				<!-- 左边 -->
				<template #left>
					<el-button class="mr-2" @click="openModel(false)" type="primary" size="mini" v-auth="'add'+auth_val">添加国家</el-button>
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量删除</el-button>
 -->
				</template>

				<!-- 高级搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="用户ID" class="mb-0">
							<el-input size="small" v-model="from.id" placeholder="搜索ID"></el-input>
						</el-form-item>
						<el-form-item label="ArenaID" class="mb-0">
							<el-input size="small" v-model="from.u_id" placeholder="搜索ArenaID"></el-input>
						</el-form-item>
						<el-form-item label="邮箱" class="mb-0">
							<el-input size="small" v-model="from.username" placeholder="搜索邮箱"></el-input>
						</el-form-item>



						<el-form-item label="状态" class="mb-0">
							<el-select v-model="from.is_read" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="已读" :value="1"></el-option>
								<el-option label="未读" :value="0"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="类型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="系统发送" :value="1"></el-option>
								<el-option label="人工发送" :value="2"></el-option>
							</el-select>
						</el-form-item>



						<el-form-item label="发送时间" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>


						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				<el-table-column align="center" sortable="custom" prop="id" width="80" label="ID">
				</el-table-column>



				<el-table-column align="center" prop="name" label="国家名称">
				</el-table-column>
				<el-table-column align="center" prop="code" label="国家代码">
				</el-table-column>

				<el-table-column align="center" prop="status" label="状态">
					<template slot-scope="scope">
						<el-button :type="scope.row.is_show ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row,2)" plain>{{scope.row.is_show ? '启用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>




				<el-table-column sortable="custom" align="center" prop="create_time" width="200" label="创建时间">
				</el-table-column>

				<el-table-column prop="id" fixed="right" align="center" width="160" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope)">编辑</el-button>

						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog title="发送站内信" :visible.sync="createModel" top="5vh">
			<!-- 表单内容 -->
			<el-form :rules="rules" ref="form" :model="form" label-width="100px">


				<el-form-item label="名称" prop="name">
					<el-input v-model="form.name" placeholder="名称" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>
				<el-form-item label="代码" prop="code">
					<el-input v-model="form.code" placeholder="代码" clearable size="small" style="width: 34%;"></el-input>
				</el-form-item>


				<el-form-item label="排序" prop="sort">
					<el-input-number v-model="form.sort" size="mini" label="排序"></el-input-number>

				</el-form-item>
				<!-- <el-form-item label="排序">
					<el-input-number size="small" v-model="form.order" :min="0"></el-input-number>
				</el-form-item> -->
				<el-form-item label="显示状态">
					<el-radio-group v-model="form.is_show" size="small">
						<el-radio :label="1" border>启用</el-radio>
						<el-radio :label="0" border>禁用</el-radio>
					</el-radio-group>
				</el-form-item>



			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>



	</div>
</template>

<script>
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				checkModel: false,
				editIndex: -1,
				//搜索数据
				from: {
					id: '',
					username: '',
					u_id: '',
					is_read: -1,
					type: -1,
					time: [],
				},
				model_title: '背景',
				auth_val: 'Country',
				preUrl: "other/countryList", //列表地址
				delAllUrl: "data/delMessageAll", //批量删除地址
				delUrl: "data/delMessage", //删除单条地址
				addUrl: "other/addCountry", //添加/修改地址
				editStatusUrl: "other/editStatusCountry", //修改状态地址
				options: [],
				tableData: [],
				form: {
					name: '',
					code: '',
					is_show: 1,
					sort: 0
				},
				prop: 'create_time',
				sort: 'descending',
				rules: {
					name: [{
							required: true,
							message: "请输入国家名称",
							trigger: 'blur',
						},

					],
					code: [{
							required: true,
							message: "请输入国家代码",
							trigger: 'blur',
						},

					]
				},
				rule_list: [],
				check_img_list: [],
				mt_info: {
					is_have: 0,
					list: {}
				}
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			//this.commonList('rule');
		},
		methods: {

			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				this.$refs.form.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 关闭模态框
					}
				})
			},



			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表单
					this.form = {
						name: '',
						code: '',
						is_show: 1,
						sort: 0
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						code: e.row.code,
						is_show: e.row.is_show,
						sort: e.row.sort,
					}

					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				console.log(this.tableData)
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空筛选条件
			clearSearch() {
				this.from = {
					id: '',
					username: '',
					u_id: '',
					is_read: -1,
					type: -1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 选择图片
		}
	}
</script>

<style>
</style>
